import React, { useContext, useEffect, useState } from "react";
import newBuildImg from "../images/new_build.png";
import ratingImg from "../images/rating.svg";
import penthouseImg from "../images/penthouse.svg";
import twonhouseImg from "../images/townhouse.svg";
import vilaImg from "../images/vila.svg";
import apartmentImg from "../images/apartments.svg";
import homestayImg from "../images/homestay.svg";
import landImg from "../images/land.svg";
import confidenceImg from "../images/confidence_img.png";
import intimateImg from "../images/intimate_white.svg";
import happyClientImg from "../images/happy_client_white.svg";
import AgentImg from "../images/agent-white.svg";
import experienceImg from "../images/experience_white.svg";
import { IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../style/Slideshow.css";
import { GetApi, PostApi } from "../api/api-service";
import { API_Path, companyName, imgBaseUrl } from "../Const";
import { AuthContext } from "../context/AuthContext";
import { fatchcompletionTypeFind } from "../components/CommonApi";
import SpinnerLoader from "../components/loader/SpinnerLoader";
import PropertySlider from "../components/PropertySlider";
import PropertyFilter from "../components/filter/PropertyFilter";
import ProjectSlider from "../components/ProjectSlider";
import { convertToSlug, onError } from "../components/CommonFun";
import SellerLeadsForm from "../components/modal/SellerLeadsForm";
import moment from "moment";
import developerLogo from "../images/developer.svg";
import Features from "../components/features/Features";
import { REMDHome, REIoIosArrow } from "../components/icons/IconSvg";
import { BsInfoCircleFill } from "react-icons/bs";
import { Accordion } from "react-bootstrap";
var residentData = [
    { value: "penthouse", name: "Penthouse", url: penthouseImg },
    { value: "townhouse", name: "Townhouse", url: twonhouseImg },
    { value: "villa", name: "Villa", url: vilaImg },
    { value: "apartment", name: "Apartments", url: apartmentImg },
    { value: "building", name: "Building", url: homestayImg },
    { value: "plot", name: "Land/Plot", url: landImg },
];
function Home() {
    const navigate = useNavigate();
    const { completionType, fetchCompletionType, fetchPurposeType } = useContext(AuthContext);
    const [ltsProperties, setLtsProperties] = useState([]);
    const [isLoader, setIsLoader] = useState({ isProject: false, isProperty: false });
    const [projectData, setProjectData] = useState([]);
    const [allNews, setAllNews] = useState([]);
    const [devLogo, setDevLogo] = useState([]);
    const [newsLoader, setNewsLoader] = useState(false);
    const [reportMdl, setReportMdl] = useState({ flag: false, data: "" });

    useEffect(() => {
        fatchNewsAndArticles();
        fetchPurposeType();
        fetchProjects();
        fatchDeveloperImg();
        fetchCompletionType();
        fechLtsProperties();
    }, []);

    const fechLtsProperties = async () => {
        try {
            setIsLoader((prevMax) => ({ ...prevMax, isProperty: true }));
            let res = await GetApi(API_Path.propertiesDetails + "/Pagination?pageNumber=1&pageSize=10");
            if (res && res.data.success) {
                let data = fatchcompletionTypeFind(completionType, res.data.data);
                setLtsProperties(data);
            }
            setIsLoader((prevMax) => ({ ...prevMax, isProperty: false }));
        } catch (error) {
            setIsLoader((prevMax) => ({ ...prevMax, isProperty: false }));
        }
    };
    const fetchProjects = async () => {
        let data = {};
        try {
            setIsLoader((prevMax) => ({ ...prevMax, isProject: true }));
            let res = await PostApi(API_Path.ProjectsDetails + `/pagination?pageNumber=${1}&pageSize=${10}`, { data: data });
            if (res && res.data.success) setProjectData(res.data.data);
            setIsLoader((prevMax) => ({ ...prevMax, isProject: false }));
        } catch (error) {
            setIsLoader((prevMax) => ({ ...prevMax, isProject: false }));
        }
    };

    const fatchNewsAndArticles = async () => {
        try {
            setNewsLoader(true);
            let res = await GetApi(API_Path.fatchNewsAndArticles + "GetAll?pageNumber=1&pageSize=4");
            if (res && res.data.success) setAllNews(res.data.data);
            setNewsLoader(false);
        } catch (error) {
            setNewsLoader(false);
        }
    };
    const fatchDeveloperImg = async () => {
        try {
            let res = await GetApi(API_Path.developerLists + "images");
            if (res && res.data.success) setDevLogo(res.data.data);
        } catch (error) {}
    };

    const handleLinkClick = () => {
        window.scrollTo(0, 0);
        navigate("/news");
    };
    const handleSellerHide = () => setReportMdl({ flag: false, data: "" });

    return (
        <>
         {/* <PageTitle title="Home" /> */}
            <div className="hero-sec">
                <div className="container">
                    <div className="hero-sec-inner">
                        {/* <h1>{companyName} is trusted in real estate</h1> */}
                        <h1>UAE & India's Luxury Real Estate Portal</h1>
                        <p>Thousands of luxury home enthusiasts just like you visit our website.</p>
                    </div>
                    <PropertyFilter />
                </div>
            </div>
            {projectData && projectData.length > 0 && (
                <div className="slider-sec">
                    <div className="container">
                        <div className="our-latest-sec">
                            <div className="our-build">
                                <REMDHome />
                                <p>Trusted {companyName}</p>
                            </div>
                            <div className="our-build-space">
                                <h2>Our Latest Projects in the UAE</h2>
                            </div>
                            {isLoader?.isProject ? (
                                <SpinnerLoader />
                            ) : (
                                <div className="slider-card project-slider-card">
                                    <ProjectSlider projectData={projectData} isFlag={true} />
                                </div>
                            )}
                        </div>
                        <div className="view-more-btn">
                            <Link to="/new-project" className="button">View All New Project <IoIosArrowForward /></Link>
                            {/* <Link to="/new-project">View All New Project</Link> */}
                        </div>
                    </div>
                </div>
            )}
            <div className="new-build-sec">
                <div className="container">
                    <div className="new-build-container">
                        <div className="new-build-left">
                            <img src={newBuildImg} alt="Dream Living Spaces Setting New Build" />
                            <div className="rating-star">
                                <img src={ratingImg} alt="Star" />
                                <p>5 Star Rating</p>
                            </div>
                        </div>
                        <div className="new-build-right">
                            <div className="our-build">
                               <REMDHome />
                                <p>Trusted {companyName}</p>
                            </div>
                            <div className="living-space-sec our-build-space">
                                <h2>Dream Living Spaces Setting New Build</h2>
                                <p>At {companyName}, we believe that every property tells a story — of ambition, lifestyle, and growth. With a strong focus on off-plan and secondary properties, we guide our clients through Dubai’s vibrant real estate market, offering opportunities that match both aspirations and investments.</p>
                                <p>Backed by over 20 years of experience, our property specialists bring a wealth of knowledge and insight to every transaction. What sets us apart is our commitment to transparency, professionalism, and personalized service. From the very first consultation to the final handover, we ensure every step is seamless, informed, and rewarding.</p>
                            </div>
                            <div className="about-btn">
                                <Link to="/about-us" className="button">
                                    About Us
                                </Link>
                                <Link to="/property/for-sale" className="property-btn">
                                    Find Property
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {ltsProperties && ltsProperties.length > 0 && (
                <div className="slider-sec">
                    <div className="container">
                        <div className="our-latest-sec">
                            <div className="our-build">
                                {/* <REMDHome /> */}
                                <REMDHome />
                                <p>Trusted {companyName}</p>
                            </div>
                            <div className="our-build-space">
                                <h2>Our Latest Properties in the UAE</h2>
                            </div>
                            {isLoader.isProperty ? (
                                <SpinnerLoader />
                            ) : (
                                <div className="slider-section swiper-slider-sec our-latest-property">
                                    <PropertySlider ltsProperties={ltsProperties} perViewFlag={false} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <div className="custom-pagination"></div>
            <div className="searching-sec">
                <div className="container">
                    <div className="searching-sec-inner">
                        <div className="our-build-space">
                            <h2>Try Searching For</h2>
                            <p>Thousands of luxury home enthusiasts just like you have found their dream home</p>
                        </div>
                        <div className="row search-info">
                            {residentData.map((item, i) => (
                                <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-xs-12 col-6" key={i}>
                                    <Link to={`property/for-sale/categories=${item.value}`}>
                                        <div className="search-info-inner">
                                            <img src={item.url} alt={item.name} />
                                            <div className="search-property">
                                                <p>{item.name}</p>
                                                {/* <span>1 Property</span> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="area-slider-sec">
                <div className="area-slider-title">
                    <div className="our-build">
                        <REMDHome />
                        <p>Trusted {companyName}</p>
                    </div>
                    <div className="our-build-space">
                        <h2>Popular Areas in Dubai</h2>
                    </div>
                </div>
                <div className="slider-section area-slider">
                    <Swiper
                        modules={[Navigation, Pagination]}
                        slidesPerView={1}
                        spaceBetween={10}
                        navigation={{ nextEl: ".next", prevEl: ".prev" }}
                        // pagination={{ clickable: true }}
                        loop={false}
                        breakpoints={{
                            //  1300: { slidesPerView: 4 },
                            1024: { slidesPerView: 5 },
                            640: { slidesPerView: 3 },
                            480: { slidesPerView: 1.6 },
                        }}
                    >
                        {slider_Ourarea.map((slide, index) => (
                            <SwiperSlide key={index}>
                                <Link to={""}>
                                    <div className="area-slider-inner">
                                        <img src={slide.img} alt="" />
                                        <div className="area-text">
                                            <h3>{slide.name}</h3>
                                            <p>{slide.properties}</p>
                                        </div>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <button className="prev" aria-label="Previous Slide">
                        ❮
                    </button>
                    <button className="next" aria-label="Next Slide">
                        ❯
                    </button>
                </div>
            </div> */}
            {allNews.length > 0 && (
                <div className="our-news-featured-sec">
                    <div className="container">
                        <div className="blog-title-info">
                            <div className="blog-head">
                                <div className="our-build">
                                    <REMDHome />
                                    <p>News and Articles</p>
                                </div>
                                <div className="our-build-space">
                                    <h2>Read what's happening in Real Estate</h2>
                                </div>
                            </div>
                            <Link to="/news" onClick={handleLinkClick}>
                                See all news and articles <IoIosArrowForward />{" "}
                            </Link>
                        </div>
                        <div className="our-blog-inner">
                            <div className="our-blog-details our_news_card">
                                {allNews
                                    .filter((type) => type.isActive)
                                    .map((item, i) => (
                                        <div className="our-project-card" key={i}>
                                            <div className="blog-card-img">
                                                <img src={imgBaseUrl + item?.filePath} alt={item.title} onError={onError} />
                                            </div>
                                            <div className="blog-info-data">
                                                <Link to={`/news/${convertToSlug(item.title)}-${item.id}`}>
                                                    <h3>{item.title}</h3>
                                                </Link>
                                                <div className="news-description">
                                                    <p>{item.shortDescription}</p>
                                                </div>
                                                <div className="news-date-time">
                                                    <div className="read-more-btn">By {companyName}</div>
                                                    <div className="blog-ftr-details">
                                                        <span>{moment(item.created, "DD-MM-YYYY hh:mm:ss A").format("DD MMM YYYY")}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {devLogo?.length > 0 ? (
                <div className="developer-sec area-slider-sec">
                    <div className="container">
                        <div className="blog-title-info">
                            <div className="blog-head">
                                <div className="our-build justify-content-start">
                                    <REMDHome />
                                    <p>Trusted {companyName}</p>
                                </div>
                                <div className="our-build-space">
                                    <h2>Projects by developers in the UAE</h2>
                                </div>
                            </div>
                            <Link to="/dev-list">
                                {/* <Link to="/new-projects/dev-list"> */}
                                All Developers <IoIosArrowForward />{" "}
                            </Link>
                        </div>
                    </div>
                    <div className="client-slider sldr-linear p-0">
                        <Swiper modules={[Autoplay]} slidesPerView={6} spaceBetween={20} pagination={{ clickable: true, el: ".client-pagination" }} speed={3000} loop={true} autoplay={{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: true }} breakpoints={{ 1200: { slidesPerView: 6 }, 992: { slidesPerView: 5 }, 768: { slidesPerView: 4 }, 576: { slidesPerView: 3 }, 0: { slidesPerView: 2 } }}>
                            {devLogo.map((slide, index) => (
                                <SwiperSlide key={index}>
                                    <div className="client-slider-details">
                                        <div className="company_info">
                                            <img
                                                src={imgBaseUrl + slide?.path}
                                                alt={slide?.name}
                                                className="img-fluid"
                                                onError={({ currentTarget }) => {
                                                    currentTarget.onerror = null;
                                                    currentTarget.src = `${developerLogo}`;
                                                }}
                                            />
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            ) : (
                <></>
            )}
            <div className="confidence-market-sec">
                <div className="container">
                    <div className="confidence-market-inner">
                        <div className="confidence-market-left">
                            <img src={confidenceImg} alt="Have Confidence in any Market with us" />
                        </div>
                        <div className="confidence-market-right">
                            <h3>Have Confidence in any Market with us</h3>
                            <p>{companyName} agents have the experience to get the job done in today’s market, backed by a robust network of over 140,000 agents in more than 9,000 offices worldwide. With our extensive global connections and deep local insights, you gain an edge that transcends what you'll find online.</p>
                            <div className="view-more-btn mt-0">
                                <Link to="/agents" className="button">Find your agent today <REIoIosArrow /></Link>
                            </div>
                        </div>
                    </div>
                    <div className="why-choose-sec">
                        <div className="our-build-space">
                            <h2>Why Choose Us ?</h2>
                            <p>Here’s just a few reasons why homeowners are choosing realty to sell their property.</p>
                        </div>
                        {/* <div className="choose-inner">
                            <div className="choose-info">
                                <div className="choose-info-img">
                                    <img src={experienceImg} alt="" />
                                </div>
                                <div className="choose-info-inner">
                                    <h3>Extensive Expertise</h3>
                                    <p>With over 20 years of experience, our property specialists bring unmatched knowledge of Dubai’s real estate market to help you make informed decisions.</p>
                                </div>
                            </div>
                            <div className="choose-info">
                                <div className="choose-info-img">
                                    <img src={happyClientImg} alt="" />
                                </div>
                                <div className="choose-info-inner">
                                    <h3>Personalized Guidance</h3>
                                    <p>We provide tailored solutions for every client, ensuring your property journey — whether off-plan or secondary — is smooth and hassle-free.</p>
                                </div>
                            </div>
                            <div className="choose-info">
                                <div className="choose-info-img">
                                    <img src={AgentImg} alt="" />
                                </div>
                                <div className="choose-info-inner">
                                    <h3>Trusted & Transparent</h3>
                                    <p>Our commitment to honesty, transparency, and professionalism ensures you can invest with confidence and peace of mind.</p>
                                </div>
                            </div>
                            <div className="choose-info">
                                <div className="choose-info-img">
                                    <img src={intimateImg} alt="" />
                                </div>
                                <div className="choose-info-inner">
                                    <h3>Long-Term Value</h3>
                                    <p>We focus on building lasting relationships and delivering properties that create real value for your future.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="choose-info-cards">
                            <div className="c4-wrap">
                                <div className="c4">
                                    <div className="badge-4"><img src={experienceImg} alt="Extensive Expertise" /></div>
                                    <h3 className="choose-info-title">Extensive Expertise</h3>
                                    <div className="choose-info-underline" style={{background:"#f15a24"}}></div>
                                    <p className="choose-info-text">With over 20 years of experience, our property specialists bring unmatched knowledge of Dubai’s real estate market to help you make informed decisions.</p>
                                </div>
                            </div>
                            <div className="c4-wrap">
                                <div className="c4">
                                    <div className="badge-4"><img src={happyClientImg} alt="Personalized Guidance" /></div>
                                    <h3 className="choose-info-title">Personalized Guidance</h3>
                                    <div className="choose-info-underline" style={{background:"#f15a24"}}></div>
                                    <p className="choose-info-text">We provide tailored solutions for every client, ensuring your property journey — whether off-plan or secondary — is smooth and hassle-free.</p>
                                </div>
                            </div>
                            <div className="c4-wrap">
                                <div className="c4">
                                    <div className="badge-4"><img src={AgentImg} alt="Trusted & Transparent" /></div>
                                    <h3 className="choose-info-title">Trusted & Transparent</h3>
                                    <div className="choose-info-underline" style={{background:"#f15a24"}}></div>
                                    <p className="choose-info-text">Our commitment to honesty, transparency, and professionalism ensures you can invest with confidence and peace of mind.</p>
                                </div>
                            </div>
                            <div className="c4-wrap">
                                <div className="c4">
                                    <div className="badge-4"><img src={intimateImg} alt="Long-Term Value" /></div>
                                    <h3 className="choose-info-title">Long-Term Value</h3>
                                    <div className="choose-info-underline" style={{background:"#f15a24"}}></div>
                                    <p className="choose-info-text">We focus on building lasting relationships and delivering properties that create real value for your future.</p>
                                </div>
                                </div>
                            </div>
                    </div>
                </div>
                {/* <div className="client-feedback-sec">
                    <div className="container">
                        <div className="client-feedback-inner">
                            <div className="our-build">
                                <REMDHome />
                                <p>Trusted {companyName}</p>
                            </div>
                            <div className="our-build-space">
                                <h2 className="mb-0">Our Client’s Feedback</h2>
                            </div>
                        </div>
                        <div className="client-slider ">
                            <Swiper modules={[Navigation, Pagination]} slidesPerView={1} spaceBetween={20} navigation={{ nextEl: ".next", prevEl: ".prev" }} pagination={{ clickable: true, el: ".client-pagination" }} loop={false} breakpoints={{ 1024: { slidesPerView: 2 }, 575: { slidesPerView: 1 } }}>
                                {slider_Clients.map((slide, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="client-slider-inner">
                                            <div className="client-slider-details  justify-content-between">
                                                <div className="client-slider-left">
                                                    <img src={slide.img} alt="" loading="lazy" />
                                                    <div className="client-slider-left-inner">
                                                        <h3>{slide.name}</h3>
                                                        <span>{slide.ceo}</span>
                                                    </div>
                                                </div>
                                                <div className="output-img">
                                                    <img src={viewOutput} alt="" />
                                                </div>
                                            </div>
                                            <div className="client-info">
                                                <p>{slide.clientinfo}</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <button className="prev" aria-label="Previous Slide">
                                ❮
                            </button>
                            <button className="next" aria-label="Next Slide">
                                ❯
                            </button>
                            <div className="client-pagination"></div>
                        </div>
                    </div>
                </div> */}
            </div>

            <div className="faq_section">
                <div className="container">
                    <div className="faq_card">
                        <div className="our-build">
                                <BsInfoCircleFill color="#f15a24" />
                                <p>FAQs</p>
                            </div>
                            <div className="our-build-space">
                                <h2>Frequently Asked Questions</h2>
                                <p className="mb-3">Find answers to common questions about buying, selling, and investing in UAE real estate through {companyName}.</p>
                            </div>
                       <div className="faq-accordion">
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header as="h3">What is {companyName}?</Accordion.Header>
                                <Accordion.Body>
                                    <bdi>{companyName}</bdi> is a modern real estate platform that connects buyers, sellers, investors, brokers, developers, landlords, and tenants through verified property listings and advanced property search tools.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header as="h3">how does it help real estate agents?</Accordion.Header>
                                <Accordion.Body>
                                  <bdi>{companyName}</bdi> helps real estate agents respond to leads faster, automate follow-ups, and convert more property inquiries into booked viewings and closed deals.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header as="h3">How do I post a property listing?</Accordion.Header>
                                <Accordion.Body>
                                    After logging in: Go to Dashboard → Click "Add Property" → Upload property details and images → Submit your listing for review.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header as="h3">How do I search for properties?</Accordion.Header>
                                <Accordion.Body>
                                    Use filters such as: Location, Property Type, Price Range, Bedrooms, Bathrooms, Furnishing, and Developer.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header as="h3">Can developers showcase new projects?</Accordion.Header>
                                <Accordion.Body>
                                    Yes. Developers can promote Off-plan Projects, New Launches, Investment Opportunities, and Featured Communities through dedicated project pages.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                    </div>
                </div>
            </div>

            <Features />

            {reportMdl.flag && <SellerLeadsForm data={reportMdl} onHide={handleSellerHide} />}
        </>
    );
}

export default Home;
